module.exports = __webpack_public_path__ + "c2cd12f6c4fe5b2caf6059a23f74bdae.png";